import { Collapsible, CollapsibleProps, Flex, HelpHover, Switch, SwitchProps } from 'components'
import { IEvent } from 'types'
import { usePermission } from 'utils'

interface Props extends Omit<CollapsibleProps, 'children' | 'label'> {
  event: Pick<IEvent, 'registrationInput' | 'registrationMode' | 'registrationSkip'>
  onUpdate: (body: Partial<IEvent>) => void
}

export default function SessionOptions({ event, onUpdate, ...rest }: Props) {
  const { registrationMode, registrationSkip, registrationInput } = event || {}

  return (
    <Collapsible label="Session Creation Options" {...rest}>
      <Flex direction="column" gap={2} alignSelf="flex-start" mt={1} width="100%">
        {registrationMode !== 'none' && (
          <SwitchWithHelp
            helpText="Allow users to skip registration using Guest mode"
            checked={registrationSkip || false}
            label="Allow skip"
            onChange={() => onUpdate({ registrationSkip: !registrationSkip })}
          />
        )}
        {(registrationMode === 'qr-code' || registrationMode === 'database') && (
          <SwitchWithHelp
            helpText="Allow user to bypass the registration with Form input mode"
            checked={registrationInput || false}
            label="Allow input"
            onChange={() => onUpdate({ registrationInput: !registrationInput })}
          />
        )}
      </Flex>
    </Collapsible>
  )
}

interface SwitchWithHelpProps extends SwitchProps {
  helpText?: string
}

function SwitchWithHelp({ helpText, ...rest }: SwitchWithHelpProps) {
  const permission = usePermission()

  return (
    <Flex justify="flex-start" align="center" gap={2}>
      <Switch
        colorPalette="primary"
        borderRadius={'11px'}
        labelProps={{ fontSize: 'sm' }}
        disabled={permission.event === 'viewer'}
        {...rest}
      />
      {helpText && <HelpHover text={helpText} borderRadius={'5px'} iconProps={{ size: 'sm' }} />}
    </Flex>
  )
}
